<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>

<app-partnership-hero></app-partnership-hero>
<section class="tw-max-w-[1380px] tw-mx-auto tw-py-[50px] tw-px-[15px]">
    <h2
        class="!tw-font-bold !tw-text-[#0F3172] !tw-text-[24px] sm:!tw-text-[30px]"
    >
        {{ "PARTNERS.PARTNERS_TITLE" | translate }}
    </h2>
    <p class="!tw-text-[14px] sm:!tw-text-[16px]">
        {{ "PARTNERS.PARTNERS_INTRO" | translate }}
    </p>
</section>
<app-partnership-listing
    [selectedLanguage]="selectedLanguage"
    [partnershipImgUrls]="
        partnershipData[0]?.partnershipDetails?.partnershipImageUrl
    "
></app-partnership-listing>
<app-partnership-info
    [partnershipData]="partnershipData"
    (openPartnershipDialog)="openPartnershipDialog($event)"
></app-partnership-info>

<app-footer [selectedLanguage]="selectedLanguage"></app-footer>
